<template>
<div>
    <div class="col-12 pb-5 mb-4" v-if="trackApplicationLoader">
        <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
    </div>
    <div class="row no-gutters body" v-else>
        <div class="col-lg-3 middle-background"></div>
        <div class="col-md-12 col-lg-6 middle-background pb-4" >
            <div class="row no-gutters">
                <br />
            </div>
            <div class="row no-gutters mt-5" v-if="!currentUserProfileId && currentUserProfileId === undefined" >
                <div class="col-lg-12 pb-3">
                <div class="row no-gutters">
                    <br />
                </div>
                <div class="ml-3 mr-3 mt-lg-2 main-card">
                    <no-profile-id-component></no-profile-id-component>
                </div>
                </div>
            </div>
            <div class=" no-gutters mt-5 main-card" v-else>
                <div class="col-lg-12" v-if="!selectedTrackApplication"> 
                    <div class="row no-gutters">
                        <br />
                    </div> 
                    <!-- <nav class="nav card-header1 d-flex justify-content-between p-1 ml-3 mr-3 mt-2 mb-3" id="nav">
                        <div class="d-flex col-12 p-0">
                            <div class=" input-group search-input p-0 mr-2 "  >
                                <div class="input-group-prepend " >
                                    <span class="input-group-text img-input-group" id="basic-text">
                                        <img :src="searchimg" class="imgborder" /> 
                                    </span>
                                </div>
                                <input
                                class="form-control input-border"
                                type="text"  @focus="enableSearchImg" @blur="disableSearchImg"
                                placeholder="Designation"  id="searchedInput" autocomplete="off"
                                aria-label="Search"  v-model="jobText"    
                                />
                                <div class="dropdown-menu" id = "dropdown" v-if="jobText.length>0">
                                    <div class="fontsize12 black60 proximanova  ml-3 mr-3 hover">
                                        <li class="list-group-item suggested-jobs action" v-for="(item,index) in searchsuggestions" :key="index"  @click="selectDesignation(item)">
                                            <img :src="suggestionSearchImg" class="imgborder suggestedImg ml-1" /> 
                                            <span class="ml-2 mr-1">{{item }} </span>
                                        </li>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="input-group search-input p-0 mr-2" >
                                <div class="input-group-prepend " >
                                    <span class="input-group-text img-input-group" id="basic-text">
                                        <img :src="locationimg" class="imgborder" /> 
                                    </span>
                                </div>
                                <input
                                class="form-control input-border"
                                type="text"  @focus="enableLocationImg" @blur="disableLocationImg"
                                placeholder="Location"  id="searchedInput" autocomplete="off"
                                aria-label="Search"  v-model="locationSearchtext"    
                                />
                                <div class="dropdown-menu" id = "dropdown" v-if="locationSearchtext.length>0">
                                    <div class="fontsize12 black60 proximanova  ml-3 mr-3 hover">
                                        <li class="list-group-item suggested-jobs action" v-for="(item,index) in searchLocations" :key="index" @click="selectJobLocation(item)">
                                            <img :src="suggestionSearchImg" class="imgborder suggestedImg ml-1" /> 
                                            <span class="ml-2 mr-1"  >{{item }}</span>
                                        </li>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="d-flex justify-content-end " v-if="jobText.length ===0 || locationSearchtext.length ===0">
                                <div class="">
                                    <a  class="btn button-create btn-color "  id="search">
                                        <span class="proximanova-semibold fontsize16 black60">Search</span>
                                    </a>
                                </div>
                            </div>
                            <div class="d-flex justify-content-end " v-if="(jobText.length > 0 && locationSearchtext.length > 0) && !applyFilters">
                                <div @click="applyFiltersForJobs">
                                    <a  class="btn button-create btn-color find-button"  id="search">
                                        <span class="fontsize16 white proximanova-semibold">Find</span>
                                    </a>
                                </div>
                            </div>
                            <div v-if="applyFilters" class="d-flex justify-content-end " @click="resetSearch">
                                <a  class="btn button-create btn-color find-button"  id="search">
                                    <span class="fontsize16 white proximanova-semibold">Clear</span>
                                </a>
                            </div>
                        </div>                        
                        
                    </nav> -->
                    <!-- <div class="col-12 pb-5 mb-4" v-if="trackApplicationLoader">
                        <img src="../assets/pageloader.svg" class="pageloader" alt="">
                    </div> 
                    <div v-else>-->
                        <div>
                            <nav class="nav ml-3 mr-3 mobileview">
                                <div class="col-12 card-header mt-3 mt-lg-4 mb-3">
                                    <div class="row no-gutters ">
                                        <ul class="nav nav-tabs proximanova-bold blue fontsize12 d-flex flex-nowrap mobviewItems">
                                        <li class="nav-item mr-lg-3 mr-md-3 mouseoveraction">                       
                                            <a
                                            class="proximanova-semibold blck80"
                                            :class="{'proximanova-semibold blue border-tab':activeJobStatusClass == 'Applied'}"
                                            @click="changePillBtnColour('Applied')"
                                            id="Applied"
                                            >Applied</a>
                                        </li>
                                        <div class="verticaline mt-1"> | </div>
                                        <li class="nav-item mr-lg-3 mr-md-3 mouseoveraction">                        
                                            <a
                                            class="proximanova-semibold blck80"
                                            :class="{'proximanova-semibold blue border-tab':activeJobStatusClass == 'Disqualified'}"
                                            id="Disqualified"
                                            @click="changePillBtnColour('Disqualified')"
                                            >Rejected</a>
                                        </li>
                                        <div class="verticaline mt-1"> | </div>
                                        <li class="nav-item mouseoveraction">                        
                                            <a
                                            class="proximanova-semibold blck80"
                                            :class="{'proximanova-semibold  blue border-tab':activeJobStatusClass == 'Review'}"
                                            id="Review"
                                            @click="changePillBtnColour('Review')"
                                            >Review</a>
                                        </li>
                                        <div class="verticaline mt-1"> | </div>
                                        <li class="nav-item mouseoveraction">                        
                                            <a
                                            class="proximanova-semibold blck80"
                                            :class="{'proximanova-semibold  blue border-tab':activeJobStatusClass == 'Assessment'}"
                                            id="Assessment"
                                            @click="changePillBtnColour('Assessment')"
                                            > Assessment</a>
                                        </li>
                                        <div class="verticaline mt-1"> | </div>
                                        <li class="nav-item mouseoveraction">                        
                                            <a
                                            class="proximanova-semibold blck80"
                                            :class="{'proximanova-semibold  blue border-tab':activeJobStatusClass == 'Shortlisted'}"
                                            id="Shortlisted"
                                            @click="changePillBtnColour('Shortlisted')"
                                            >Shortlisted</a>
                                        </li>
                                        <div class="verticaline mt-1"> | </div>
                                        <li class="nav-item mouseoveraction">                        
                                            <a
                                            class="proximanova-semibold blck80"
                                            :class="{'proximanova-semibold  blue border-tab':activeJobStatusClass == 'Interview'}"
                                            id="Interview"
                                            @click="changePillBtnColour('Interview')"
                                            >Interview</a>
                                        </li>
                                        <div class="verticaline mt-1"> | </div>
                                        <li class="nav-item mouseoveraction">                        
                                            <a
                                            class="proximanova-semibold blck80"
                                            :class="{'proximanova-semibold  blue border-tab':activeJobStatusClass == 'Selected'}"
                                            id="Selected"
                                            @click="changePillBtnColour('Selected')"
                                            >Selected</a>
                                        </li>
                                        <div class="verticaline mt-1"> | </div>
                                        <li class="nav-item mouseoveraction">                        
                                            <a
                                            class="proximanova-semibold blck80"
                                            :class="{'proximanova-semibold  blue border-tab':activeJobStatusClass == 'Hired'}"
                                            id="Hired"
                                            @click="changePillBtnColour('Hired')"
                                            >Hired</a>
                                        </li>
                                        </ul>
                                    </div>
                                </div>
                                </nav>
                        <div class="col-12 d-flex justify-content-between mt-3 mr-2  ml-lg-2 ">
                            <!-- <div class="fontsize12 black60 proximanova ml-3" v-if="!applyFilters">
                                <p>Applied - 0{{resultCount}}</p>
                            </div>
                            <div class="fontsize12 black60 proximanova ml-3" v-else>
                                <div class="row no-gutters ml-3">
                                    <div v-if="selectedlocations.length>0" class="row">
                                        <div v-for="(location,index) in selectedlocations" :key="index">
                                            <span
                                            class="fontsize14 black80 proximanova pillbtn activeSub mr-2 mr-lg-3 p-1"                           
                                            >{{location}}<span class="nobtn"> - 01</span>
                                            <img src="../assets/Close.svg" @click="resetLocationSelection(location)"></span>
                                        </div>
                                    </div>
                                    <div v-if="sortBy.length>0" class="row ml-3">
                                        <div v-for="(status,index) in sortBy" :key="index">
                                            <span
                                            class="fontsize14 black80 proximanova pillbtn activeSub mr-2 mr-lg-3 p-1"                           
                                            >{{status}}<span class="nobtn"> - 01</span>
                                            <img src="../assets/Close.svg" @click="resetSortSelection(status)"></span>
                                        </div>
                                    </div>
                                </div>
                               
                            </div> -->
                            <div></div>
                            <div class="d-flex justify-content-end mr-3"> 
                                <div class="navtoPage mr-2 pointer" @click="openDropDown">
                                    <img src="../assets/FiltersNew.svg" alt="filetrs" class="img-fluid ml-2 mr-2" />  
                                    <label class="proximanova-semibold black70 fontsize12 " >Filters</label>
                                              
                                </div>
                                <div class="filtermenu dropdown-menu"  v-if="showdropdown" id = "filterDropdown" >
                                    <div class="p-2">
                                        <div  class="fontsize12 proximanova-bold black d-flex justify-content-between col-12 mb-2 ml-2 mt-1">
                                            <span>Filters </span>
                                            <div class="closebtnmouseover">
                                                <img src="../assets/Close.svg" alt="close" class="img-fluid closebtn float-right" @click="closeDropDown">
                                            </div>
                                        </div>
                                        <div class="line1"></div>
                                        <div class="d-flex input-group col-12 mt-2 mb-2">
                                            <input
                                            class="form-control proximanova-semibold fontsize12 black60 "
                                            type="text"            
                                            placeholder="Search Location" id="locationtext" autocomplete="off"
                                            aria-label="Search"  @input ="searchlocation" v-model="locationText"  
                                            />
                                            <div class="input-group-append">
                                                <span class="input-group-append img-input-group" >
                                                <img src="../assets/Search.svg" alt="search" class="imgborder-search imgborder1"/>
                                                </span>
                                            </div>
                                            <div class="dropdown-menu col-10 ml-3 d-flex"  v-if="showLocationDropdown && locationText.length> 0"    > 
                                                <div class="col-12 fontsize12 black60 proximanova borderradius5 hover">
                                                    <li class="list-group-item" v-for="(item,index) in searchedLocations" :key="index" @click="selectLocation(item.cityName)">
                                                        {{item.cityName}}
                                                    </li>
                                                </div>
                                            </div> 
                                        </div>
                                        <div class=" col-12 mt-1  font14-opacity60">
                                            <div class="row d-flex justify-content-between ml-2 mb-2 mt-2">
                                                <div  v-if="showNewLocations">
                                                    <div class="col-6" v-for="(item,index) in newSelectedLocations" :key="index">
                                                        <input type="checkbox" v-model="selectedlocations" checked class="form-check-input check-with-label"  :id="item" :value="item">
                                                        <label class="fontsize12 black60 proximanova label-for-check " for="index">{{item}}</label>
                                                    </div>
                                                </div>
                                                <div class="col-6" v-for="(item,index) in defaultLocations" :key="index">
                                                    <input type="checkbox" v-model="selectedlocations" checked="checked" class="form-check-input check-with-label" :id="item" :value="item">
                                                    <label class="fontsize12 black60 proximanova label-for-check " for="index">{{item}}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-end mr-2" v-if="newSelectedLocations.length> 0">
                                            <a class="fontsize12 black60 proximanova hover" v-if="!showNewLocations" @click="showNewLocations = true">View More</a>
                                            <a class="fontsize12 black60 proximanova hover" v-if="showNewLocations" @click="showNewLocations = false">View Less</a>
                                        </div>
                                        <div class="col-12">
                                            <div class="horizonline1"></div> 
                                        </div>
                                        <span class="proximanova-semibold fontsize12 black60 ml-3" :class="{'text-color' :sortBy.length > 0}">Sort by</span>
                                        <div class=" col-12 mt-1  font14-opacity60">
                                            <div class="row d-flex justify-content-between ml-2 mb-2 mt-2">
                                                <div class="col-6" v-for="(item,index) in defaultSortBy" :key="index">
                                                    <input type="checkbox" v-model="sortBy" checked="checked" class="form-check-input check-with-label"  :id="item" :value="item">
                                                    <label class="fontsize12 black60 proximanova label-for-check " for="index">{{item}}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="horizonline1"></div> 
                                        </div>
                                        <div class="d-flex justify-content-end  pr-3 pt-3 pb-2">
                                            <a  class="btn button-create btn-color mr-2 mouseoverbtn1 borderradius20" @click="reset" id="search">
                                                <span class="proximanova-semibold fontsize16 black80">Reset</span>
                                            </a>
                                            <a  v-on:click="search"  class="btn button-create mouseoverbtn2 backgroundcolorblack white borderradius20" :disabled="basicinfo" id="search">
                                                <span class="fontsize16 white proximanova-semibold">Show Results</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="appliedJobsList.length > 0" class="pb-5">
                            <div class="shadow card mb-2 ml-3 mr-3 mt-lg-2" v-for="(job, index) in appliedJobsList" :key="index">
                                <div class="card-body homevideoslist">
                                    <div class="d-flex flex-column">    
                                        <div class="row no-gutters videocardhead d-flex justify-content-between p-3">
                                            <div class="col-12 d-flex justify-content-between ">
                                                <div class="col-12 d-flex p-0">
                                                    <div class="">
                                                        <img v-if="job.companyProfileLink" alt="companylogo" oncontextmenu="return false;" class="img-fluid rounded-circle profile-border jobProfImg loadingBgImg"  :src="job.companyProfileLink" />                                                    
                                                        <img v-else src="../assets/Profile_placehlder.svg" alt="companylogo" class="jobImg jobProfImg rounded-circle">
                                                    </div>
                                                    <div class="d-flex flex-column col-md-11 pl-2 pl-md-3 mt-0 text-capitalize p-0">
                                                        <div class="d-flex justify-content-between">
                                                            <div class="col-11 pl-0 pr-0 fontsize20 black proximanova-bold nameBlock pointer" @click="openSelectedJobApplication(job)">{{job.jobTitle}}</div>
                                                            <!-- <div class="col-1 pl-0 pr-0 my-auto">
                                                                <img src="../assets/More_Actions.svg">
                                                            </div> -->
                                                        </div>
                                                        <div class="proximanova black font16">{{job.companyName}}</div> 
                                                        <div class="d-flex ">  
                                                            <div class="proximanova fontsize14 black60 pt-1" v-if="job.industry">{{job.industry}}</div>     
                                                            <div class="verticaline ml-2 mr-2" v-if="job.industry && job.country"> | </div>      
                                                            <div class="proximanova fontsize14 black60 pl-1 pt-1"> {{job.country}} </div>
                                                        </div>
                                                        <div class="d-flex pt-1">  
                                                            <div>  
                                                                <span class="proximanova-semibold fontsize14 black">Applied {{job.creationD | moment("from", "now", true)}} ago </span>                                              
                                                                <span class="verticaline ml-2 mr-2"> | </span> 
                                                                <span class="proximanova fontsize10 black60 pl-1"> {{job.jobApplicantCount}} Applications </span> 
                                                            </div>  
                                                        </div>  
                                                    </div>
                                                </div>
                                                <!-- <div class="col-2 d-flex justify-content-end">
                                                    <div >
                                                        <div>
                                                            <img src="../assets/More_Actions.svg">
                                                        </div>
                                                    </div>
                                                </div>   -->
                                            </div>
                                        </div>
                                        <div class="borderbottom mt-2"></div>
                                        <div class="backgroundcolor1  d-flex mobileview p-2 justify-content-between">
                                            <div v-for="(status, index) in job.empJobApplicantStatus" :key="index">
                                                <div class="d-flex p-2 pl-3 pr-3 mr-1" v-if="status !== null" :class="{'rejStatus' :job.empJobApplicantStatus[index].creationD !== null}">
                                                    <div>
                                                        <img src="../assets/JobTotalRecieved.svg" class="statusImg" v-if="status.jobStatus === 'Applied' && status.creationD !== null" alt="totalreceived">
                                                        <img src="../assets/JobTotalRecieved_rej.svg" class="statusImg" v-if="status.jobStatus === 'Applied' && status.creationD == null" alt="totalreceived">
                                                        <img src="../assets/JobReview.svg" class="statusImg" v-if="status.jobStatus === 'Review' && status.creationD !== null" alt="review">
                                                        <img src="../assets/Review_rej.svg" class="statusImg" v-if="status.jobStatus === 'Review' && status.creationD == null" alt="review">
                                                        <img src="../assets/JobAssessment.svg" class="statusImg" v-if="status.jobStatus === 'Assessment' && status.creationD !== null" alt="assessment">
                                                        <img src="../assets/Assessment_rej.svg" class="statusImg" v-if="status.jobStatus === 'Assessment' && status.creationD == null" alt="assessment">
                                                        <img src="../assets/JobShortlisted.svg" class="statusImg" v-if="status.jobStatus === 'Shortlisted' && status.creationD !== null" alt="shortlisted">
                                                        <img src="../assets/Shortlisted_rej.svg" class="statusImg" v-if="status.jobStatus === 'Shortlisted' && status.creationD == null" alt="shortlisted">
                                                        <img src="../assets/JobDisqualified.svg" class="statusImg" v-if="status.jobStatus === 'Disqualified' && status.creationD !== null" alt="disqualified">
                                                        <img src="../assets/Disqualified_rej.svg" class="statusImg" v-if="status.jobStatus === 'Disqualified' && status.creationD == null" alt="disqualified">
                                                        <img src="../assets/JobInterview.svg" class="statusImg" v-if="status.jobStatus === 'Interview' && status.creationD !== null" alt="interview">
                                                        <img src="../assets/Interview_rej.svg" class="statusImg" v-if="status.jobStatus === 'Interview' && status.creationD == null" alt="interview">
                                                        <img src="../assets/JobSelected.svg" class="statusImg" v-if="status.jobStatus === 'Selected' && status.creationD !== null" alt="selected">
                                                        <img src="../assets/Selected_rej.svg" class="statusImg" v-if="status.jobStatus === 'Selected' && status.creationD == null" alt="selected">
                                                        <img src="../assets/JobHired.svg" class="statusImg" v-if="status.jobStatus === 'Hired' && status.creationD !== null" alt="hired">
                                                        <img src="../assets/Hired_rej.svg" class="statusImg" v-if="status.jobStatus === 'Hired' && status.creationD == null" alt="hired">
                                                    </div>
                                                    <div class="d-flex flex-column mt-0 text-capitalize p-0 my-auto">
                                                        <span class="proximanova fontsize10 black60 pl-2" v-if="status.jobStatus != 'Disqualified'">{{status.jobStatus}}</span>
                                                        <span class="proximanova fontsize10 black60 pl-2" v-if="status.jobStatus == 'Disqualified'">Rejected</span>
                                                        <span class="proximanova fontsize8 black60 pl-2">{{ status.creationD | moment("DD/MM/YYYY") }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 pb-5 mt-5" v-if="instanceLoader">
                            <img src="../assets/pageloader.svg" class="instanceloader" alt="loadinganimation">
                        </div>
                        <div v-if="appliedJobsList.length < 1 || appliedJobsList === undefined" class="ml-3 mr-3 pb-5 mt-3">
                            <div v-if="!trackApplicationLoader && !instanceLoader">
                                <no-records-found :message="noRecordsFoundMessage"></no-records-found>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12" v-else>
                    <selected-track-application :selectedtrackJobDetails="selectedtrackJobDetails"></selected-track-application>
                </div>
            </div>
        </div>
        <div class="col middle-background">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters">
            <br />
          </div>
          <pendingActivities />
        </div>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
    </div>
</div>
</template>
<script>
import pendingActivities from "../components/PendingActivities.vue";
import httpuserprofile from "@/js/http-userprofile.js";
import selectedTrackApplication from './SelectedJobTracking.vue'
import NoProfileIdComponent from '../components/NoProfileId.vue'
import NoRecordsFound from '../components/NoRecordsFound.vue'
import APIerrorModal from '../components/APIerrorpopup.vue'
import sessionUtils from '@/js/session-util.js'
import { bus } from "../main";
import router from '../router';
export default{
    components : {
        pendingActivities,
        selectedTrackApplication,
        NoProfileIdComponent,
        NoRecordsFound,
        APIerrorModal
    },
data(){
    return{
        currentUserProfileId : null,
        selectedTrackApplication : false,
        displayAPIerrorModal : false,
        activeJobStatusClass : 'Applied',
        selectedtrackJobDetails : null,
        noRecordsFoundMessage : 'No records found with selected job status',
        appliedJobsList : [],
        instanceAppliedJobsList : [],
        activeClass: 'Track',
        trackApplicationLoader : true,
        instanceLoader : false,
        showSuggested: false,
        showTracking :true,
        resultCount: 0,
        showdropdown: false,
        locationText: '',
        jobText: '',
        locationSearchtext: '',       
        searchedLocations : [],
        showLocationDropdown: false,
        newSelectedLocations: [],
        selectedlocations: [],
        sortBy: [],    
        isScrolled: false, 
        trackLimit : 10,
        trackOffset : 0,
        basicinfo: false,   
        searchimg: require('../assets/Designation.svg'),
        suggestionSearchImg: require('../assets/Designation.svg'),
        locationimg: require('../assets/Location.svg'),
        searchsuggestions: ['Product','Product Designer','Product Manager','Product Reviewer'],
        searchLocations:  ['Boston','Boston,USA','USA','Texas,USA'],
        showNewLocations:false,
        applyFilters: false,
        defaultLocations : ['Hyderabad','Bangalore','Delhi','Pune'],
        defaultSortBy: ['Review','Assessment','Shortlisted','Interview','Selected','Hired','Disqualified'],
        followersProfilePictures: [require('../assets/Group2.svg'),require('../assets/Group2.svg'),require('../assets/Group2.svg'),require('../assets/Group2.svg')]
    }
},
methods:{
    closeAPIerrorModal(){
        this.displayAPIerrorModal = false;
    },
    // not in used
    toggleActiveClass(elementId) {        
        this.activeClass = elementId;
        if (elementId == "suggested") {
            this.showSuggested = true;
            this.showTracking = false
            this.suggested();
        }else if (elementId == "Saved") {
            this.showSuggested = false;
            this.showTracking = false
        }else if (elementId == "Posted") {
            this.showSuggested = false;  
            this.showTracking = false      
        }else {
            this.showSuggested = false;
            this.showTracking = true
        }
    },
    //this will invoke after click on each job section button
    changePillBtnColour(status){
        this.sortBy = [];
        this.activeJobStatusClass = status;
        if(status === 'Applied'){
            this.applyFilters = false
        }else{
            this.applyFilters = true
            this.sortBy.push(this.activeJobStatusClass)
        }
        this.trackOffset = 0;
        this.instanceLoader = true;
        this.appliedJobsList = [];
        this.instanceAppliedJobsList = [];
        this.getAppliedJobsList()
    },
    //fetched applied jobs list
    getAppliedJobsList(){
        this.instanceAppliedJobsList = [];
        let appliedFilters = 'N'
        if(this.applyFilters){
            appliedFilters = 'Y'
        }
        httpuserprofile.get('/userprofile/GetListOfJobsAppliedByUser?profileId='+this.currentUserProfileId+'&locations='+this.selectedlocations+'&sortby='+this.sortBy+'&applyFilters='+appliedFilters+'&limit='+this.trackLimit+'&offset='+this.trackOffset)
        //  httpuserprofile.get('userProfile/GetListOfJobsAppliedByUser?profileId=406&locations=&sortby=&applyFilters=N')
        .then((response) => {
            console.log("applied jobs list : ", response)
            this.trackApplicationLoader = false;
            this.instanceLoader = false;
            this.isScrolled = false;
            this.instanceAppliedJobsList = response.data;
            if(this.instanceAppliedJobsList.length > 0) {
                console.log("inside")
                this.appliedJobsList = this.appliedJobsList.concat(this.instanceAppliedJobsList)
            }
            console.log("applied list : ", this.appliedJobsList)
            // this.resultCount = this.appliedJobsList.length;
        }).catch((e) => {
            this.trackApplicationLoader = false;
            this.instanceLoader = false;
            if(appliedFilters == 'Y'){
                this.displayAPIerrorModal = true;
            }
            console.log(e)
        })
    },
    // open selected jobs status screen if clicks on job title
    openSelectedJobApplication(job){
        // this.selectedtrackJobDetails = job;
        // this.selectedTrackApplication = true;
        if(job.jobAliasId){
        this.$router.push({name: 'selectedJob', params: { id: job.jobAliasId}});
        }else{
            var vm = this;
            vm.$toast.success("No job alisid present")
        }
    },
    //not in use
    selectDesignation(job){
        this.jobText = job;
    },
    //not in use
    selectJobLocation(location){
        this.locationSearchtext = location;
    },
    //open/close filter dropdown
    openDropDown(){
        this.showdropdown = true
    },
    closeDropDown(){
        this.showdropdown = false
    },
    // this will invoke after click on reset button on filter dropdown
    reset(){
        this.applyFilters = false;
        this.selectedlocations = [];
        this.sortBy = [];
        this.showdropdown = false;
        this.activeJobStatusClass = "Applied";
        this.trackOffset = 0;
        this.instanceLoader = true;
        this.appliedJobsList =[];
        this.instanceAppliedJobsList = [];
        this.getAppliedJobsList()
    },
    //not in use
    resetLocationSelection(text){
        console.log(text)
        var index = this.selectedlocations.indexOf(text);
        this.selectedlocations.splice(index, 1);       
        if(this.selectedlocations.length ===0 && this.sortBy.length ===0){
            this.applyFilters = false
        }
    },
    //not in use
    enableSearchImg(){
        this.searchimg = require('../assets/DesignationBlue.svg')
    },
    //not in use
    disableSearchImg(){
        if(this.jobText.length === 0){
            this.searchimg = require('../assets/Designation.svg')
        }        
    },
    //not in use
    enableLocationImg(){
        this.locationimg = require('../assets/Locationblue.svg')
    },
    //not in use
    disableLocationImg(){
        if(this.locationSearchtext.length === 0){
            this.locationimg = require('../assets/Location.svg')
        }        
    },
    //not in use
    applyFiltersForJobs(){
        console.log('entr')
        this.applyFilters = true;
    },
    //not in use
    resetSearch(){
        this.jobText = "";
        this.locationSearchtext = "";
        this.applyFilters = false
        this.disableSearchImg();
        this.disableLocationImg();
    },
    //not in use
    resetSortSelection(test){
        var index2 = this.sortBy.indexOf(test);
        
        this.sortBy.splice(index2,1);
        if(this.selectedlocations.length ===0 && this.sortBy.length ===0){
            this.applyFilters = false
        }
    },
    //this will invoke after click on getresults button on filter dropdown
    // get filtered applied jobs list
    search(){
        console.log(this.selectedlocations[0])
        console.log(this.sortBy)
        this.applyFilters = true;
        this.showdropdown = false;
        this.trackOffset = 0;
        this.instanceLoader = true;
        this.appliedJobsList = [];
        this.instanceAppliedJobsList = [];
        this.getAppliedJobsList()
    },
    // To search the location name based on text in location field of filters
      searchlocation(){
        if(this.locationText.length < 1  ){ 
            this.searchedLocations  = [];       
            return;
        }   
        var self = this;
        setTimeout(function() {
          // TODO
            httpuserprofile.get('/searchController/searchbyLocation?searchText='+self.locationText+'&stateCode=')
            .then(response => {    
                self.searchedLocations = [];    
                self.searchedLocations = response.data;
                if(self.searchedLocations.length > 0){
                    self.showLocationDropdown  = true;
                }                
            }).catch(error=>{   
            console.log(error);  
            })      
        }, 1500); 
    },
    // To select the required location from dropdown
      selectLocation(name){
      if(!this.newSelectedLocations.includes(name) && !this.defaultLocations.includes(name)){        
        this.selectedlocations = this.selectedlocations.concat(name);     
        this.newSelectedLocations = this.newSelectedLocations.concat(name); 
      }   
        this.searchedLocations = [];
        this.locationText = '';
        this.showLocationDropdown  = false;
    },
        handleScrollTrackApplications () {       
            if(!this.isScrolled && this.instanceAppliedJobsList.length >= 9){          
                if (((window.innerHeight + window.scrollY +1) >= document.body.offsetHeight) ) {     
                    this.isScrolled = true;    
                    this.instanceLoader = true;
                    this.trackOffset = this.trackOffset+10; 
                    this.getAppliedJobsList(); 
                }        
            }    
        },
    },
    mounted(){
        this.currentUserProfileId = sessionUtils.getUserProfileId();
        if(this.currentUserProfileId){
        this.getAppliedJobsList()
        }else{
            this.trackApplicationLoader = false;
        }
        bus.$on("gotoTrackApplicationsList", data => {
            this.selectedTrackApplication = data;
        }) 
        bus.$on("refreshDatawhenInSameTrackPage", data => {
            if(data){
                this.reset()
            }
        })
        window.addEventListener('scroll', this.handleScrollTrackApplications);
    },
    beforeDestroy(){
        bus.$off('gotoTrackApplicationsList')
        bus.$off('refreshDatawhenInSameTrackPage')
        window.removeEventListener('scroll', this.handleScrollTrackApplications)
    }
}
</script>
<style scoped>
#search{
    background-color: white
}
#searchedInput{
    background-color: white !important;
}
#basic-text{
    background-color: white !important;
    border-radius: 10px 0px 0px 10px;
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.mobileview{
    overflow: auto;
}   
/* Hide scrollbar for Chrome, Safari and Opera */
.mobileview::-webkit-scrollbar {
    display: none;
}

.card-header1 {
  border: 1px solid #d9dce1;
  opacity: 1;
  border-radius: 8px;
}  
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
} 
.instanceloader{
  width: 10%;
  margin-left: 46%;
}
.list-group-item{
    padding: .25rem 0.25rem;
    border: none;
    border-radius: 5px;
}
.list-group-item:hover{
    background: rgba(31,31,31,.1);
}
#locationtext{
    border-radius: 10px 0 0 10px;
}
.imgborder1 {
  padding: 10px 15px 10px 10px;
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 0px 10px 10px 0px;
}
.main-badge {
    background: linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%) !important;
    font-size: 12px !important;
    /* opacity: 30%; */
}
.input-group-append{
  margin-left: 0 !important;
}
.mobviewItems {
    /* font-size: 10px  !important; */
    overflow-x: auto !important;
  }
  /* .mobviewItems::-webkit-scrollbar {
    display: none;
} */
.card-header {
  padding: 5px 10px 5px 10px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 1;
  border-radius: 8px !important;
  background-color: #f0f2f5;
}
.nav-tabs {
  border-bottom: none !important;
}
#filterDropdown{
  left : unset !important;
  z-index: 3;
  width: 320px !important;
  cursor: pointer;
}
.navtoPage{
    cursor: pointer;
}
#dropdown{
    min-width: 100%;
    margin-top: 5px;
}
.dropdown-menu{
  cursor: pointer;
  position: absolute;
  display:block;    
  color: black;
  box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
  border: none;
  margin-top: 0px;   
  border-radius: 10px  !important;
}
.nameBlock:hover{
	color:#007AFF !important;
	text-decoration: underline;
	white-space: nowrap;
	}
.closebtnmouseover {
    border: 1px solid white;
}
.closebtnmouseover:hover {

  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.form-control {
  background-color: rgb(161, 166, 179,0.1) !important;
  border: 0px solid #ced4da !important;
  /* border-radius: 0px 10px 10px 0px !important; */
}
.activeVideoSub {
  background-color: #d6e9ff;
  border: 1px solid #9ecbff;
  color: #0078ff;
}
.btn-color{
  border-color: rgba(31, 31, 31,0.1);
}
.form-control:focus{
    outline: none !important;
    box-shadow: none !important;   
    border-radius: 10px;
    background-color: rgba(161, 166, 179,0.1);
    border: #DDDFE5;   
}

.sign-in-button{
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: 600;
  color: #1F1F1F;
  opacity: 30%;
  transition : ease-out 0.3s;
  POSITION : relative;
  z-index : 1
}
.sign-in-button::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 30%;
  right : 30%;
  bottom : 0;
  opacity : 0;
  content : "";
  background-color :  rgba(255,255,255,.3);
}
.sign-in-button:hover:before {
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  opacity : 1;
  z-index : -1
}

.card-body{
    padding:0 !important;
}
.card-footer{
    background-color: rgba(161, 166, 179,0.1);
    padding: unset !important;
}
.rejStatus{
     background-color: rgba(161, 166, 179,0.1);
     border-radius: 10px;
}
.statusImg{
    vertical-align: baseline;
    width: 20px;
    height: 20px;
}
.jobProfImg{
    width: 56px;
    height: 56px;
}
.activeSub {
  background-color: #d6e9ff;
  border: 1px solid #9ecbff;
  color: #0078ff;
}
.pillbtn {
  cursor: pointer;
  border: 1px solid #dbdbdb;
  border-radius: 16px;
  padding-left: 8px !important;
  padding-right: 9px !important;
}
.nobtn{
    color: black;
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5%;
    padding-right: 5%;
  }
}
@media screen and (min-width: 550px) and (max-width : 768px){
    .jobProfImg {
        height: 50px;
    }
    .pageloader {
        width: 12%;
        margin-top: 25%;
        margin-left: 46%;
    } 
}
@media screen and (max-width : 550px) {
    .jobProfImg{
        height: 47px;
    }
    .nameBlock{
        font-size: 18px !important;
    }
    .pageloader {
        width: 15%;
        margin-top: 25%;
        margin-left: 42%;
    } 
}
</style>
